import { twMerge } from 'tailwind-merge';

interface BackButtonProps {
  disabled?: boolean;
  buttonClassName?: string;
  arrowClassName?: string;
  onClick?: () => void;
}

export const BackButton = ({
  disabled,
  buttonClassName,
  arrowClassName,
  onClick,
}: BackButtonProps) => {
  return (
    <div
      className={twMerge(
        'flex justify-center items-center w-9 min-w-9 h-9 min-h-9 rounded-full bg-gradient-blue shadow-md hover:cursor-pointer',
        buttonClassName,
        disabled && 'opacity-50 cursor-not-allowed'
      )}
      onClick={disabled ? undefined : onClick}
    >
      <i
        className={twMerge(
          'ki-filled ki-arrow-left text-white',
          arrowClassName
        )}
      ></i>
    </div>
  );
};
